/* eslint-disable react/prop-types */
import React from 'react';

interface IconProps {
  IconClass?: string;
}

export const ChevronLeft: React.FC<IconProps> = ({ IconClass }) => (
  <svg
    width="18"
    height="16"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={IconClass}
  >
    <path
      d="M7.73272 15.7905C8.03264 16.0762 8.50738 16.0646 8.79306 15.7647C9.07875 15.4648 9.06721 14.99 8.76728 14.7043L2.51587 8.74973L17.25 8.74973C17.6642 8.74973 18 8.41394 18 7.99973C18 7.58551 17.6642 7.24973 17.25 7.24973L2.51577 7.24973L8.76728 1.29502C9.06721 1.00933 9.07875 0.534599 8.79306 0.234673C8.50738 -0.065254 8.03264 -0.0767973 7.73272 0.20889L0.313785 7.27559C0.144859 7.4365 0.0449066 7.64174 0.0139294 7.85512C0.00478934 7.90191 -4.32463e-09 7.95026 0 7.99973C4.3331e-09 8.04929 0.00480748 8.09773 0.0139828 8.14461C0.045022 8.35785 0.144956 8.56295 0.313786 8.72377L7.73272 15.7905Z"
      fill="#2277DB"
    />
  </svg>
);

export default ChevronLeft;
